// 🔒 비밀번호 규칙 체크리스트 (공용) — 관리자 메뉴 [정책 설정 > 비밀번호 정책] 에 기입된 항목을
//   사용자 화면에 **그대로** 보여준다 (2026-08-25 사용자).
//   쓰는 곳: 로그인 임시비번 강제변경 화면 · 개인 설정 비밀번호 변경 섹션 — 두 곳의 문구·판정이 항상 같아야 한다.
//   🔴 규칙을 여기서 다시 정의하지 말 것 — 항상 loadPasswordPolicy() → passwordRules() 결과를 받는다.
import { useTranslation } from 'react-i18next';
import type { PasswordRule } from '../../api/passwordPolicy';

export interface PasswordRulesProps {
	rules: PasswordRule[];
	/** 입력 전에는 전부 중립색 — 아직 틀린 게 아니라 '요구사항 목록'으로 읽히게 한다. */
	touched?: boolean;
	/** 로그인 화면 black/navy 다크 배경에서 호출 시 true (테마 토큰이 안 닿는 풀블리드 영역). */
	dark?: boolean;
	testId?: string;
}

export default function PasswordRules({ rules, touched = false, dark = false, testId = 'password-rules' }: PasswordRulesProps) {
	const { t } = useTranslation();
	if (rules.length === 0) return null;
	const muted = dark ? 'rgba(255,255,255,.55)' : '#667085';
	return (
		<div data-testid={testId}>
			<div className="mb-1 px-1 text-ui-sm font-semibold" style={{ color: dark ? 'rgba(255,255,255,.75)' : '#344054' }}>
				🛡 {t('settings.pwPolicyTitle')}
			</div>
			<ul className="space-y-1 px-1">
				{rules.map((rule) => {
					const met = touched && rule.ok;
					// ❌ 입력 시작 후 미충족 규칙은 빨간색 (2026-09-01 사용자) — 어떤 조건이 남았는지 즉시 보이게.
					//   입력 전(touched=false)은 종전대로 중립색 '요구사항 목록'.
					const failed = touched && !rule.ok;
					return (
						<li key={rule.key} className="flex items-center gap-1.5 text-ui-sm"
							style={{ color: met ? '#12B76A' : failed ? '#F04438' : muted }}
							data-rule-ok={touched ? String(rule.ok) : undefined}>
							<span aria-hidden="true">{met ? '✓' : failed ? '✕' : '·'}</span>
							<span>{rule.label}</span>
						</li>
					);
				})}
			</ul>
		</div>
	);
}
